import { Component } from '@angular/core';
import { ReleaseTimelineModalService } from 'src/app/services/shared/release-timeline-modal.service';
import {
  RELEASE_HISTORY,
  ReleaseEntry,
} from 'src/app/data/release-history';

/**
 * Modale "Roadmap Diakonix" — mostrato cliccando sulla versione in
 * sidebar. Timeline verticale con le milestone di rilascio.
 *
 * Feature pubblica (visibile a tutti gli utenti, incluso il cliente).
 * Linguaggio user-facing, no jargon interno — vedi il file
 * `release-history.ts` per rationale sul livello di dettaglio.
 *
 * Il modale è keyboard-accessible: ESC → close.
 */
@Component({
  selector: 'app-release-timeline-modal',
  templateUrl: './release-timeline-modal.component.html',
  styleUrls: ['./release-timeline-modal.component.scss'],
  standalone: false,
})
export class ReleaseTimelineModalComponent {
  readonly entries: readonly ReleaseEntry[] = RELEASE_HISTORY;

  constructor(public readonly timeline: ReleaseTimelineModalService) {}

  /**
   * Formatta la data per il display.
   * - "YYYY" → "Anno YYYY"
   * - "YYYY-MM-DD" → "gg MMM YYYY" locale IT
   * - Interval "YYYY-YYYY" → "YYYY–YYYY"
   * - Fallback: raw string
   */
  formatDate(raw: string): string {
    // Range di anni (es. "2022-2026")
    if (/^\d{4}-\d{4}$/.test(raw)) {
      return raw.replace('-', '–');
    }
    // Solo anno (es. "2022")
    if (/^\d{4}$/.test(raw)) {
      return raw;
    }
    // Data completa YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return raw;
      const months = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu',
                      'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    }
    return raw;
  }

  /** Handler ESC per chiudere il modale. */
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') this.timeline.close();
  }
}
